import { publish } from '../messagingApi';
import { v4 as uuid } from 'uuid';
export var NotificationStreamTopic;
(function (NotificationStreamTopic) {
  NotificationStreamTopic["MonoNotification"] = "mono-notification";
})(NotificationStreamTopic || (NotificationStreamTopic = {}));
export function notify(notificationMessage, options) {
  var notificationId = uuid();
  publish('*', NotificationStreamTopic.MonoNotification, {
    id: notificationId,
    notificationMessage: notificationMessage,
    options: options,
    timeStamp: Date.now()
  });
  return Promise.resolve(true);
}